import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Wraps page routes with a fade + slight slide on every navigation.
const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const [stage, setStage] = useState("in");
  const [content, setContent] = useState(children);

  useEffect(() => {
    setStage("out");
    const t = setTimeout(() => {
      setContent(children);
      setStage("in");
    }, 180);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => { setContent(children); }, [children]);

  return (
    <div
      className={`transition-all duration-300 ease-out ${stage === "in" ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}
    >
      {content}
    </div>
  );
};

export default PageTransition;
